declare var window: any;

const PreventNavigation = {
  mounted(this: any) {
    // Browser close/refresh/back — native dialog (can't be customized)
    this.beforeUnloadHandler = (e: BeforeUnloadEvent) => {
      e.preventDefault();
    };
    window.addEventListener("beforeunload", this.beforeUnloadHandler);

    // LiveView navigation — show custom confirmation popup
    this.navigationHandler = (e: any) => {
      e.preventDefault();
      e.stopImmediatePropagation();

      const modal = document.getElementById("confirmation-popup");
      if (modal) {
        modal.querySelector("[data-popup-message]")!.textContent =
          "Bulk action is still in progress. Are you sure you want to leave?";
        window.liveSocket.execJS(modal, modal.getAttribute("data-exec-open"));

        const confirmHandler = () => {
          // Remove guards and allow navigation
          window.removeEventListener("beforeunload", this.beforeUnloadHandler);
          window.removeEventListener(
            "phx:page-loading-start",
            this.navigationHandler,
          );
          // Replay the original navigation
          if (e.detail && e.detail.to) {
            window.location.href = e.detail.to;
          }
        };

        window.addEventListener("phx:confirm", confirmHandler, { once: true });
        window.addEventListener(
          "phx:cancel",
          () => window.removeEventListener("phx:confirm", confirmHandler),
          { once: true },
        );
      }
    };
    window.addEventListener("phx:page-loading-start", this.navigationHandler);
  },

  destroyed(this: any) {
    window.removeEventListener("beforeunload", this.beforeUnloadHandler);
    window.removeEventListener(
      "phx:page-loading-start",
      this.navigationHandler,
    );
  },
};

export default PreventNavigation;
